/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import { useUnstyled as c, classNames as r, uDropDownsBase as u } from "@progress/kendo-react-common";
import { getItemValue as m } from "./utils.mjs";
const i = (e) => e.preventDefault(), p = (e) => {
  const { selected: s, defaultItem: o, textField: n } = e, t = c(), a = t && t.uDropDownsBase;
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      onClick: e.onClick,
      onMouseDown: i,
      style: { position: "unset" },
      className: r(u.optionLabel({ c: a, selected: s }))
    },
    m(o, n) || ""
  );
};
export {
  p as default
};
